const API_DOMAIN = import.meta.env.VITE_APP_CMS_API_DOMAIN;

export const API_ROOT = `${API_DOMAIN}/api-cms/v1/`;
